import { AppBar, IconButton, Toolbar, Typography, Box } from "@mui/material";
import { ArrowBackIos } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import NotebookIcon from "@/fragments/NotebookIcon";
import CurrentUserDrawer from "@/components/CurrentUserDrawer";

export default function PageAppBar() {
  const navigate = useNavigate();
  return (
    <AppBar
      position="fixed"
      elevation={0}
      style={{ background: "rgba(19,19,19,.9)" }}
    >
      <Toolbar
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <IconButton onClick={() => navigate(-1)}>
          <ArrowBackIos />
        </IconButton>

        <Box sx={{ display: "flex", alignItems: "center" }}>
          <NotebookIcon size={24} />
          <Typography
            style={{
              fontFamily: "'Montserrat Alternates', sans-serif",
              fontWeight: 700,
              fontSize: "1.8rem",
              marginLeft: "12px",
            }}
          >
            console
          </Typography>
        </Box>

        <CurrentUserDrawer />
      </Toolbar>
    </AppBar>
  );
}
